import { useMemo } from 'react';
import { gql } from '@soundxyz/gql-string';
import { SUPER_MINTER_V2_ADDRESS } from '@soundxyz/sdk/contract/edition-v2/abi/super-minter-v2';
import {
  type FragmentType,
  getFragment,
  ReleaseSuperMinterV2InfoFragmentDoc,
} from '@graphql/reactQuery';

/*#__PURE__*/ gql(/* GraphQL */ `
  fragment ReleaseSuperMinterV2Info on Release {
    listing {
      __typename
      ... on TieredEditionListing {
        id
        schedules {
          id
          minterAddress
        }
      }
    }
  }
`);

export function useIsReleaseSuperMinterV2({
  release,
}: {
  release: FragmentType<ReleaseSuperMinterV2InfoFragmentDoc> | null | undefined;
}) {
  const info = getFragment(ReleaseSuperMinterV2InfoFragmentDoc, release);

  return useMemo(() => {
    const lowercaseMinterAddress = SUPER_MINTER_V2_ADDRESS.toLowerCase();
    return info?.listing?.schedules.some(
      v => v.minterAddress.toLowerCase() === lowercaseMinterAddress,
    );
  }, [info]);
}
